import React from 'react';
import BaseValidator from 'services/validations/base-validator';
import Const from 'const';

class AtLeastOneTeamWasChosenForEachStackValidator extends BaseValidator {
    protected runValidation(): void {
        // @ts-ignore
        const {stacking} = this.dependencies;
        const checkedTeamNamesOfPrimaryStack = stacking.getCheckedTeamNamesByStackNumber(
            Const.MLB_NON_CONTROLLED_FIRST_GROUP,
        );
        const checkedTeamNamesOfSecondaryStack = stacking.getCheckedTeamNamesByStackNumber(
            Const.MLB_NON_CONTROLLED_SECOND_GROUP,
        );

        if (!checkedTeamNamesOfPrimaryStack.length || !checkedTeamNamesOfSecondaryStack.length) {
            this.addError('Should be at least one team chosen for each Stack.');
        }
    }
}

export default AtLeastOneTeamWasChosenForEachStackValidator;
